// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner-border[data-v-753de60f]{margin:50px 50%}", "",{"version":3,"sources":["webpack://./resources/js/vue/Web/Common/Clinic/ClinicOnlineMedical.vue"],"names":[],"mappings":"AACA,iCACI,eAAJ","sourcesContent":["\n.spinner-border{\n    margin: 50px 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
